import styled from "styled-components"

export const GlobalWrapper = styled.div`
  width: 100%;
  /* overflow-x: hidden; */
`
export const PageWrapper = styled.div`
  width: 1250px;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.laptopSmall}) {
    width: 100%;
    max-width: 860px;
    margin: 0 auto;
    padding: 0 30px;
  }
`
export const OverflowWrapper = styled.main`
  overflow-x: hidden;
  position: relative;
  max-width: 100vw;
  width: 100%;
`
